<div class="modal-backdrop" (click)="closed.emit()"></div>

<div class="modal-panel" (click)="$event.stopPropagation()">
  <!-- Left: controls -->
  <div class="controls-panel">

    <!-- Colorize -->
    <div class="control-group">
      <div class="control-label">Colorize</div>
      <div class="color-row">
        <div
          class="color-swatch"
          [style.background-color]="colorize || '#ffffff'"
          [class.no-color]="!colorize"
          [colorPicker]="colorize || '#ffffff'"
          (colorPickerChange)="onColorizeChanged($event)"
          [cpAlphaChannel]="'disabled'"
          [cpSaveClickOutside]="true"
          [cpCloseClickOutside]="true"
          cpPosition="right"
          title="Pick colorize color"
        ></div>
        <button
          *ngIf="colorize"
          class="clear-btn"
          (click)="clearColorize()"
          title="Remove colorize"
        >
          <nw-icon type="close" [size]="12" color="#666"></nw-icon>
        </button>
      </div>
    </div>

    <!-- Radius -->
    <div class="control-group">
      <div class="control-label">Radius <span class="control-value">{{ radius }}px</span></div>
      <input
        type="range"
        class="radius-slider"
        [value]="radius"
        min="0"
        max="200"
        step="1"
        (input)="onRadiusChanged(+$any($event.target).value)"
      />
    </div>

    <!-- Crop -->
    <div class="control-group">
      <div class="control-label">Crop</div>
      <button class="icon-btn" (click)="enterCropMode()" title="Crop image">
        <nw-icon type="crop" [size]="20" color="#555"></nw-icon>
      </button>
    </div>

  </div>

  <!-- Right: image preview (normal mode) -->
  <div class="image-preview" *ngIf="!cropMode">
    <div
      class="preview-frame"
      [style.border-radius.px]="radius"
    >
      <img
        *ngIf="imageUrl"
        [src]="imageUrl"
        [style.border-radius.px]="radius"
      />
      <div
        *ngIf="colorize && imageUrl"
        class="colorize-overlay"
        [style.background-color]="colorize"
        [style.border-radius.px]="radius"
      ></div>
      <div *ngIf="!imageUrl" class="no-image">No image</div>
    </div>
  </div>

  <!-- Right: crop mode -->
  <div class="crop-mode" *ngIf="cropMode">
    <div class="crop-actions">
      <button class="action-btn" (click)="saveCrop()" title="Apply crop">
        <nw-icon type="check" [size]="18" color="#fff"></nw-icon>
      </button>
      <button class="action-btn danger" (click)="discardCrop()" title="Discard">
        <nw-icon type="close" [size]="18" color="#fff"></nw-icon>
      </button>
    </div>
    <div class="crop-canvas" #cropCanvas>
      <img *ngIf="imageUrl" [src]="imageUrl" class="crop-source-img" draggable="false" />
      <div
        class="crop-selection"
        [style.left.%]="cropRect.x * 100"
        [style.top.%]="cropRect.y * 100"
        [style.width.%]="cropRect.w * 100"
        [style.height.%]="cropRect.h * 100"
        (mousedown)="onCropMouseDown($event, 'move')"
      >
        <div class="ch nw" (mousedown)="onCropMouseDown($event, 'nw')"></div>
        <div class="ch ne" (mousedown)="onCropMouseDown($event, 'ne')"></div>
        <div class="ch sw" (mousedown)="onCropMouseDown($event, 'sw')"></div>
        <div class="ch se" (mousedown)="onCropMouseDown($event, 'se')"></div>
      </div>
    </div>
  </div>

  <!-- Close (hidden in crop mode — use crop actions instead) -->
  <button class="close-btn" *ngIf="!cropMode" (click)="closed.emit()" title="Close">
    <nw-icon type="close" [size]="16" color="#333"></nw-icon>
  </button>
</div>
